import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';
import { TypedUser } from "interface/user.model";
import { TypedVehicle } from "./vehicle.query";
import { TypedTripManifest } from "./trip_manifest.query";


export enum ENUM_VEHICLE_TRIP_TYPE {
    PASSENGER_SERVICE = "PASSENGER_SERVICE", // chở khách
    MAINTENANCE = "MAINTENANCE",             // đi bảo dưỡng / sửa chữa
    INTERNAL_MOVE = "INTERNAL_MOVE",         // di chuyển nội bộ
    REFUEL = "REFUEL",                       // đi đổ xăng / sạc điện
    INSPECTION = "INSPECTION",               // đăng kiểm / kiểm tra xe
    DELIVERY = "DELIVERY",                   // giao đồ / gửi hàng
    PRIVATE_TRIP = "PRIVATE_TRIP",           // đi cá nhân / đi chơi
    TEST_DRIVE = "TEST_DRIVE",               // chạy thử xe
    RESCUE = "RESCUE",                       // cứu hộ / hỗ trợ xe khác
    OTHER = "OTHER",                         // khác
}

export interface TypedVehicle_log {
    id?: string;
    vehicle_id?: string;
    driver_id?: string;
    distance?: number;
    start_address?: string;
    start_time?: string;
    end_address?: string;
    end_time?: string;
    note?: string;
    title?: string;


    file_passenger_listing?: string;
    file_trip_log?: string;

    trip_type?: string; // ENUM_VEHICLE_TRIP_TYPE

    createdAt?: any;
    updatedAt?: string;

    /** Bảng nối ... */
    driver_data?: TypedUser;
    vehicle_data?: TypedVehicle;
    trip_manifest?: TypedTripManifest;

}



type IQuery = TypedVehicle_log & IQueryParams;


/*
* List of all app
*/
export function useGetVehiclelogs(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["vehicle_log/fetch_entity_list", object],
        queryFn: () => axios.get<TypedVehicle_log[]>(`/vehicle_log${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: true,
    });
}



export function useGetVehiclelog(vehicle_id: string) {
    return useQuery({
        queryKey: ['vehicle_log/fetch_entity'],
        queryFn: () => axios.get<TypedVehicle_log>(`/vehicle_log/${vehicle_id}`).then((response) => response.data),
        retry: 1,
        enabled: !!vehicle_id,
    });
}


export function useUpdateVehiclelog() {
    return useMutation({
        mutationKey: ['vehicle_log/update_entity'],
        mutationFn: ({ id, ...rest }: TypedVehicle_log) => axios.patch<TypedVehicle_log>(`/vehicle_log/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle_log/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle_log/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity'] });
        }
    });
}


export function useMutateCreateVehiclelog() {
    return useMutation({
        mutationKey: ['vehicle_log/create_entity'],
        mutationFn: (entity: TypedVehicle_log) => axios.post<TypedVehicle_log>(`/vehicle_log`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle_log/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity'] });
        }
    });
}

export function useMutateDeleteVehiclelog() {
    return useMutation({
        mutationKey: ['vehicle_log/delete_entity'],
        mutationFn: (id: any) => axios.delete<TypedVehicle_log>(`/vehicle_log/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['vehicle_log/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle/fetch_entity'] });
        }
    });
}



/** Tạo bảng kê khách */
export function useMutateCreatePassengerListing() {
    return useMutation({
        mutationKey: ["vehicle_log/create_passenger_listing"],
        mutationFn: (vehicle_log_id: string) => axios.post(`/vehicle_log/passenger_listing/${vehicle_log_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle_log/fetch_entity_list'] });
        },
        retry: 1,
    });
}

/** Tạo bảng nhật trình */
export function useMutateTripLogListing() {
    return useMutation({
        mutationKey: ["vehicle_log/create_trip_log"],
        mutationFn: (vehicle_log_id: string) => axios.post(`/vehicle_log/trip_log/${vehicle_log_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['vehicle_log/fetch_entity_list'] });
        },
        retry: 1,
    });
}


/** Tải về excel bản đang xem */
export function useDownloadVehicleLog() {
    return useMutation({
        mutationKey: ["vehicle_log/download"],
        mutationFn: (object: IQuery) => axios.get<Blob>(`/vehicle_log/download/${helpers.buildEndUrl(object)}`, { responseType: 'blob', }).then(response => response.data),
    })
}


/** trong trường hợp không tạo tự động được, thì vui lòng bấm NÚT LÀY */
export function useMutateVehicleLogSync() {
    return useMutation({
        mutationKey: ["vehicle_log/sync_trip_log"],
        mutationFn: (trip_manifest_id: string) => axios.post(`/vehicle_log/sync-vehicle-log/${trip_manifest_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
        },
        retry: 1,
    });
}